import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/components/analytics/create-cta-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackEventOnMount"] */ "/vercel/path0/apps/frontend/components/analytics/track-event-on-mount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/frontend/components/landing/lazy-showcase-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/frontend/components/Logo.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/public/landing/d1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/public/landing/d12.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.7_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.64.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.7_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.64.1/node_modules/next/dist/client/image-component.js");
